export enum DefectStatus {
    open = 0,
    closed = 1,
    inProgress = 2,
    rectified = 3,
    expired = 4
}
